import React from "react";
import { PaletteMode } from "@mui/material/styles";
import ThemeModeContext from "components/ThemeModeProvider/ThemeModeContext";

type Props = {
  children: React.ReactNode;
};

const ThemeModeProvider: React.FC<Props> = ({ children }) => {
  const OBJECTIVE_THEME_KEY = "objective-preferred-theme";

  const preferredTheme = localStorage.getItem(OBJECTIVE_THEME_KEY) as PaletteMode;

  const [themeMode, setThemeMode] = React.useState<PaletteMode>("light");

  // We let them choose the theme, but if not, use the inherited one
  React.useEffect(() => {
    if (preferredTheme) {
      setThemeMode(preferredTheme);
      return;
    }

    const prefersDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
    setThemeMode(prefersDarkMode ? "dark" : "light");
  }, [preferredTheme]);

  const toggleThemeMode = React.useCallback(() => {
    const updatedMode = themeMode === "dark" ? "light" : "dark";
    setThemeMode(updatedMode);
    localStorage.setItem(OBJECTIVE_THEME_KEY, updatedMode);
  }, [themeMode]);

  const value = React.useMemo(() => {
    return { mode: themeMode, toggleThemeMode };
  }, [themeMode, toggleThemeMode]);

  return <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>;
};

export default ThemeModeProvider;
